export default __webpack_public_path__ + "static/media/mike.8af8bcf1.png";